var CategoryMapper = function (categoryResponse, skipFilters) {
    if (skipFilters === void 0) { skipFilters = []; }
    var mfL1LevelData = [];
    var mfL2LevelData = {};
    var mappedResult = {
        mfL1LevelData: mfL1LevelData,
        mfL2LevelData: mfL2LevelData,
    };
    try {
        if (categoryResponse === null || categoryResponse === void 0 ? void 0 : categoryResponse.data) {
            categoryResponse.data.sort(function (a, b) { return a.productTypeDisplayOrder - b.productTypeDisplayOrder; });
            categoryResponse.data.forEach(function (itemL1) {
                mfL1LevelData.push({
                    label: itemL1.name,
                    value: itemL1.name,
                    productTypeId: itemL1.productTypeId,
                });
                mfL2LevelData[itemL1.name] = [];
                if (itemL1.popularList && !skipFilters.includes("Popular")) {
                    itemL1.popularList.sort(function (a, b) { return a.order - b.order; });
                    mfL2LevelData[itemL1.name].push({
                        label: "Focused",
                        value: "Popular",
                        mfL3LevelData: handleCreateL3Data(itemL1.popularList),
                    });
                }
                categoryResponse.data.sort(function (a, b) { return a.productTypeDisplayOrder - b.productTypeDisplayOrder; });
                itemL1.productList.forEach(function (itemL2, index) {
                    var _a;
                    itemL2.categoryList.sort(function (a, b) { return a.order - b.order; });
                    mfL2LevelData[itemL1.name].push({
                        label: itemL2.productName,
                        value: (_a = itemL2 === null || itemL2 === void 0 ? void 0 : itemL2.productCode) === null || _a === void 0 ? void 0 : _a.toString(),
                        mfL3LevelData: handleCreateL3Data(itemL2.categoryList),
                    });
                    mfL2LevelData[itemL1.name][index].mfL3LevelData = mfL2LevelData[itemL1.name][index].mfL3LevelData.map(function (itemL3) {
                        return {
                            eventKey: itemL3.eventKey,
                            title: itemL3.title,
                            url: itemL3.url,
                        };
                    });
                });
            });
        }
    }
    catch (e) {
        return mappedResult;
    }
    return mappedResult;
};
export default CategoryMapper;
var handleCreateL3Data = function (categoryData) {
    var localDataArray = [];
    categoryData.map(function (item) {
        var _a;
        localDataArray.push({
            eventKey: (_a = item === null || item === void 0 ? void 0 : item.categoryCode) === null || _a === void 0 ? void 0 : _a.toString(),
            title: item.categoryName,
            url: item.url,
            tabContent: undefined,
        });
    });
    return localDataArray;
};
